import { useCallback, useEffect, useRef } from 'react'

/**
 * Returns a debounced version of `callback`. Pending calls are cancelled on
 * unmount. The latest `callback` is always used.
 */
const useDebouncedCallback = (callback, delay) => {
  const timeoutRef = useRef(null)
  const callbackRef = useRef(callback)
  callbackRef.current = callback

  useEffect(() => () => clearTimeout(timeoutRef.current), [])

  return useCallback(
    (...args) => {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => callbackRef.current(...args), delay)
    },
    [delay],
  )
}

export default useDebouncedCallback
